export const isNullOrEmpty = (input) => {
  return input && input.trim() !== "";
};

export const formatString = (text, delimeter) => {
  const data = text.replace(" – ", " ").trim();
  return data ? data.replace(/\s+/g, delimeter).toLowerCase() : "";
};

// export const buildCourseDetailsURI = (
//   subCategory,
//   courseName,
//   courseID,
//   isBundle = false
// ) => {
//   return subCategory
//     ? `${!isBundle ? "/categories/" : "/bundle/"}${formatString(
//       subCategory,
//       "-"
//     )}/${formatString(courseName, "-")}-${courseID}`
//     : `${!isBundle ? "/categories/" : "/bundle/"}${formatString(
//       courseName,
//       "-"
//     )}-${courseID}`;
// };
export const buildCourseDetailsURI = (
  subCategory,
  courseName,
  courseID,
  isBundle = false
) => {
  return subCategory ? `${!isBundle ? `/categories/${courseID}`:""}` :`${""}`;
};
export const buildCourseDetailsURI1 = (
  subCategory,
  courseName,
  courseID,
  isBundle = false
) => {
  if (courseName && courseID) {
    return `/categories/${courseID}`;
  }
  return "";
};
export function toBase64(file, index) {
  return new Promise((resolve, reject) => {
    let reader = new FileReader();
    reader.onload = function () {
      return resolve({
        fileNumber: index + 1,
        base64: reader.result,
        fileName: file.name.substr(0, file.name.lastIndexOf(".")),
        fileExt: file.name.substr(file.name.lastIndexOf(".") + 1),
        fileSize: file.size,
      });
    };
    reader.onerror = function (error) {
      return reject(error);
    };
    reader.readAsDataURL(file);
  });
}

const calculateVideoLength = (file, reader, resolve) => {
  var video = document.createElement("video");
  video.preload = "metadata";

  video.onloadedmetadata = function () {
    window.URL.revokeObjectURL(video.src);
    return resolve({ blob: reader.result, duration: video.duration });
  };

  video.src = URL.createObjectURL(file);
};

export function toBinary(file) {
  return new Promise((resolve, reject) => {
    let reader = new FileReader();
    reader.onload = function () {
      if (["video/mp4", "video/mov"].includes(file.type)) {
        //console.log("hai");
        calculateVideoLength(file, reader, resolve);
      } else {
        //console.log("oii");
        return resolve({ blob: reader.result });
      }
    };
    reader.onerror = function (error) {
      return reject(error);
    };
    reader.readAsArrayBuffer(file);
  });
}

export const isAuthorized = (userRole, authorizedRoles) => {
  return generateRoles(userRole).some((role) => authorizedRoles.includes(role));
};

export const generateRoles = (userRoles) => {
  return Object.entries(
    Object.freeze({
      Admin: 1,
      Student: 2,
      Institute: 3,
      Instructor: 4,
      Parent: 5,
    })
  )
    .filter(([key, value]) => userRoles.includes(value))
    .map(([key, value]) => key);
};

export const getS3URL = (fileName) => {
  return `${process.env.REACT_APP_COURSE_API_BASEURL}/${fileName}`;
};

export const handleViewsFormat = (n) => {
  if (n < 1e3) return n;
  if (n >= 1e3 && n < 1e6) return +(n / 1e3).toFixed(1) + "K";
  if (n >= 1e6 && n < 1e9) return +(n / 1e6).toFixed(1) + "M";
  if (n >= 1e9 && n < 1e12) return +(n / 1e9).toFixed(1) + "B";
  if (n >= 1e12) return +(n / 1e12).toFixed(1) + "T";
};

export const emailVaildation = (email) => {
  const re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};

export const pwd = (password1) => {
  const re = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@#$%^&+=!#?*-]).{8,}$/;
  return re.test(password1);
};

export const userNa = (userN) => {
  const re = /^[A-Za-z0-9_]{5,}$/;
  return re.test(userN);
};

export const validatePhoneNumber = (phone) => {
  const re = /^\s*(?:\+?(\d{1,3}))?[- .(]*(\d{3})[- .)]*(\d{3})[- .]*(\d{4})(?: *x(\d+))?\s*$/;
  return re.test(phone);
};


export const validateFirstName = (name) => {
  const firstName = name?.length >= 2 && name !== "";
  return firstName;
};

export const validateLastName = (name) => {
  const lastName = name?.length >= 2 && name !== "";
  return lastName;
};

export const street_vaildation = (street) => {
  const streetName = street?.length > 2 && street !== "";
  return streetName;
};

export const validateUnitNumber = (unit) => {
  const re = /^(\d{1}|\d{2}|\d{3}|\d{4}|\d{5}|\d{6})$/;
  return re.test(unit);
};

export const validateCityName = (city) => {
  const cityName = city?.length > 2 && city !== "";
  return cityName;
};

export const validateProvinceName = (province) => {
  const provinceName = province?.length > 2 && province !== "";
  return provinceName;
};

export const validateCountryName = (country) => {
  const countryName = country?.length > 2 && country !== "";
  return countryName;
};

export const validatePinCode = (pincode) => {
  const re = /^(?=.*[a-zA-Z\d].*)[a-zA-Z\d!@#$%&*]{3,10}$/;
  return re.test(pincode);
};

export const getPaginatedData = (courseData, currentPage, rowsPerPage = 10) => {
  const startIndex = currentPage * rowsPerPage - rowsPerPage;
  const endIndex = startIndex + rowsPerPage;
  return {
    data: courseData?.slice(startIndex, endIndex),
    startIndex: startIndex + 1,
    totalPageCount: Math.ceil(courseData?.length / 10),
  };
};

export const extractCSV = () => {
  let tableHeaders = Array.from(document.querySelectorAll("th"))
    .map((item) => {
      let title = item.innerText
        .split("\n")
        .filter((str) => str !== 0)
        .join(" ");
      return title;
    })
    .join(",");

  const rows = Array.from(document.querySelectorAll("tr")).reduce(
    (arr, currRow) => {
      if (currRow.querySelector("th")) return arr;

      const cells = Array.from(currRow.querySelectorAll("td"))
        .map((item) => item.innerText)
        .join(",");
      return arr.concat([cells]);
    },
    []
  );

  return tableHeaders + "\n" + rows.join("\n");
};

export const downloadCSV = (csv, fileName) => {
  const csvFile = new Blob([csv], { type: "text/csv" });
  const downloadLink = document.createElement("a");
  // sets the name for the download file
  downloadLink.download = `${fileName ? fileName : "test"}.csv`;
  // sets the url to the window URL created from csv file above
  downloadLink.href = window.URL.createObjectURL(csvFile);
  // creates link, but does not display it.
  downloadLink.style.display = "none";
  // add link to body so click function below works
  document.body.appendChild(downloadLink);

  downloadLink.click();
};

export const addDash = (str) => {
  return str.replace(/\s+/g, "-"); 
};
export const removeDash = (str) => {
  return str.replace(/-/g, " "); 
};
